import { NgClass } from '@angular/common'
import { ChangeDetectionStrategy, Component, HostListener, signal, WritableSignal } from '@angular/core'

@Component({
  selector: 'app-event-time-picker-dropdown-panel',
  standalone: true,
  imports: [NgClass],
  styleUrls: ['./event-time-picker-dropdown-panel.component.scss'],
  templateUrl: './event-time-picker-dropdown-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventTimePickerDropdownPanelComponent {
  public panelId: WritableSignal<string> = signal('')
  public hourOptions: WritableSignal<readonly string[]> = signal([])
  public minuteOptions: WritableSignal<readonly string[]> = signal([])
  public selectedHour: WritableSignal<string> = signal('')
  public selectedMinute: WritableSignal<string> = signal('')
  public onHourSelect?: (value: string) => void
  public onMinuteSelect?: (value: string) => void
  public onEscapeClose?: () => void

  @HostListener('document:keydown', ['$event'])
  /**
   * @description Close panel on Escape key for keyboard UX parity with native popovers.
   * @param event - Keyboard event from document.
   */
  protected onDocumentKeydown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.onEscapeClose?.()
    }
  }

  /**
   * @description Check selected state for hour option rendering.
   * @param h - Hour token.
   * @returns `true` when hour matches current selection.
   */
  protected hourIsSelected(h: string): boolean {
    return h === this.selectedHour()
  }

  /**
   * @description Check selected state for minute option rendering.
   * @param m - Minute token.
   * @returns `true` when minute matches current selection.
   */
  protected minuteIsSelected(m: string): boolean {
    return m === this.selectedMinute()
  }

  /**
   * @description Update selected hour and notify parent handler.
   * @param h - Hour token.
   */
  protected emitHour(h: string): void {
    this.selectedHour.set(h)
    this.onHourSelect?.(h)
  }

  /**
   * @description Update selected minute and notify parent handler.
   * @param m - Minute token.
   */
  protected emitMinute(m: string): void {
    this.selectedMinute.set(m)
    this.onMinuteSelect?.(m)
  }
}
